angular.module('app.controllers').controller('AuthLoginCtrl', function (utils, $state, UserService, notify, $translate) {
    const vm = this;

    if (UserService.isAuthenticated()) {
        $state.go('restricted.dashboard_main');
    } else {
        // sprawdzamy, czy wymuszono zapamiętanie
        const info = notify.info($translate.instant('auth.signin_check_remembered'));
        UserService.checkSessions().then(
            () => {
                info.close();
                notify.info($translate.instant('auth.signin_ok'));
                $state.go('restricted.dashboard_main');
            },
            () => {
                info.close();
            }
        );
    }

    vm.registerFormActive = false;
    vm.credentials = {
        email: '',
        password: '',
        remember: '',
    };

    vm.doAuth = () => {
        const info = notify.info($translate.instant('auth.signing'));

        UserService.login(vm.credentials).then(
            () => {
                info.close();
                notify.success($translate.instant('auth.signin_ok'));
                $state.go('restricted.dashboard_main');
            },
            (data) => {
                info.close();
                vm.credentials.password = '';
                notify.danger($translate.instant(data.message));
            }
        );
    };

    const $loginCard = $('#Login-Card');
    const $loginForm = $('#Login-Form');
    const $loginPasswordReset = $('#Login-PasswordReset');

    // show login form (hide other forms)
    const loginFormShow = () => {
        $loginForm.show().siblings().hide();
    };

    // show password reset form (hide other forms)
    const passwordResetShow = () => {
        $loginPasswordReset.show().siblings().hide();
    };

    vm.backToLogin = ($event) => {
        $event.preventDefault();
        vm.registerFormActive = false;
        utils.card_show_hide($loginCard, undefined, loginFormShow, undefined);
    };

    vm.passwordReset = ($event) => {
        $event.preventDefault();
        utils.card_show_hide($loginCard, undefined, passwordResetShow, undefined);
    };

    vm.emailForReset = '';
    vm.doPasswordReset = () => {
        const info = notify.info($translate.instant('sending'), notify.config('timeoutVeryLong'));
        UserService.passwordReset(vm.emailForReset).then(
            () => {
                info.close();
                notify.success($translate.instant('auth.reset_password_sent'), notify.config('timeoutLong'));
            },
            () => {
                info.close();
                notify.danger($translate.instant('auth.reset_password_error'), notify.config('timeoutLong'));
            }
        );
    };
});
